const initialState = {
  isLoading: false,
  totalRegistros: 0,
  metodoConservacao: [],
  id: 0,
  nome: '',
  excluido: false,
  loja: null,
  page: 0,
  limit: 10,
  order: 'nome',
  direction: 'asc',
  term: ''
}

export function metodoConservacao(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_METODOCONSERVACAO':
      return {
        ...state,
        metodoConservacao: action.metodoConservacao,
        totalRegistros: action.totalRegistros
      }
    case 'METODOCONSERVACAO_DETAIL':
      return {
        ...state,
        isLoading: false,
        id: action.metodoConservacao.id,
        nome: action.metodoConservacao.nome,
        excluido: action.metodoConservacao.excluido,
      }
    case 'METODOCONSERVACAO_UPDATED':
      return state
    case 'METODOCONSERVACAO_CLEAR':
      return {
        ...initialState,
        page: state.page,
        limit: state.limit,
        order: state.order,
        direction: state.direction,
        term: state.term,
      }
    case 'METODOCONSERVACAO_CLEAR_ALL':
      return {
        ...state,
        metodoConservacao: []
      }
    case 'METODOCONSERVACAO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'METODOCONSERVACAO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'METODOCONSERVACAO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
